/*
 * Project: LegalPlace assistant
 * File: src/app/log/log_entry.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


class LpLogEntry {
  constructor(type, message) {
    this.create(type, message);
  }

  create(type, message = '') {
    this.type = type;
    this.message = message;
    this.time = new Date();
    this.trace = new Error(message);
  }
}


export default LpLogEntry;



// WEBPACK FOOTER //
// ./src/app/log/log_entry.js